<template>
  <div class="receive">
    <div v-if="info">
      <div class="status-content">
        <div class="item success1" v-if="status == '已领取'">
          <div class="item-top">
            <span>已领取</span>
          </div>
          <div class="time" v-if="info.created_at"
            >于{{ info.created_at | filterTime }}成功领取</div
          >
        </div>
        <div class="item success" v-else>
          <div class="item-top">
            <span class="iconfont icon-gou"></span><span>领取成功</span>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="prize-content">
        <div class="prize-list">
          <div
            class="prize-item"
            v-for="(item, index) in info.invited_prize_list"
            :key="index"
          >
            <span class="prize-name">{{ item.prize_name }}</span>
            <span>x 1</span>
          </div>
        </div>
        <div class="btn">
          <span>来自</span>
          <img class="avatar" :src="info.head_img" alt="" />
          <span>{{ info.truename }}</span>
          <span>的赠送</span>
        </div>
      </div>
      <!-- 客服 -->
      <div class="service-content">
        <div class="tip">
          请扫描助教的二维码，在后续的体验中将会全程陪同您，如有任何疑问，可随时联系您的助教为您解答哦～
        </div>
        <img class="qrcode" :src="info.assistant_code" alt="" />
        <div class="text">长按添加助教</div>
      </div>
    </div>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#999"
      color="#999"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      loaded: false,
      status: '已领取',
      info: null
    }
  },
  filters: {
    filterTime(str) {
      if (!str) {
        return ''
      }
      let res = ''
      str = str.replace(/-/g, '/')
      let cTime = new Date(str)
      let hours = cTime.getHours()
      hours = hours < 10 ? '0' + hours : hours
      res =
        cTime.getFullYear() +
        '年' +
        (cTime.getMonth() + 1) +
        '月' +
        cTime.getDate() +
        '日' +
        ' ' +
        cTime.getHours() +
        ':' +
        cTime.getMinutes() +
        '分'
      return res
    }
  },
  created() {
    this.getParams()
    this.getData()
  },
  methods: {
    getParams() {
      this.status = this.$route.query.status
    },
    getData() {
      let params = {
        activity_id: 1
      }
      this.$http
        .getBaseApp('member/ActivitySys/getReceivePrize', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.info = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.receive {
  min-height: 100vh;
  overflow: hidden;
  padding: 0px 20px;
  box-sizing: border-box;
  background: #f9f9f9;
  .status-content {
    .success {
      padding: 50px 0px 30px;
    }
    .success1 {
      padding: 50px 0px 18px;
    }
    .item {
      text-align: center;
    }
    .item-top {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 28px;
    }
    .time {
      margin-top: 3px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000;
      line-height: 17px;
    }
    .iconfont {
      margin-right: 10px;
      width: 24px;
      height: 24px;
      background: #6236ff;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }
  }
  .prize-content {
    background: #ffffff;
    border-radius: 12px;
    padding: 8px 24px 17px;
    box-sizing: border-box;
    margin-bottom: 16px;
    .prize-list {
      .prize-item {
        display: flex;
        align-items: center;
        padding: 10px 0px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        border-bottom: 1px dashed #e8e8e8;
        .prize-name {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          white-space: normal;
          text-overflow: ellipsis;
          margin-right: 20px;
        }
      }
      .prize-item:last-child {
        border-bottom: none;
      }
    }
    .btn {
      margin-top: 6px;
      height: 31px;
      background: #f7f7f7;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      .avatar {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        overflow: hidden;
        margin: 0px 5px;
      }
    }
  }
  .service-content {
    padding: 32px 23px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 12px;
    margin-bottom: 127px;
    .tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #000000;
      line-height: 24px;
      margin-bottom: 21px;
    }
    .qrcode {
      margin: 0 auto;
      width: 190px;
      height: 190px;
      margin-bottom: 9px;
    }
    .text {
      text-align: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
    }
  }
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
  z-index: 1;
}
</style>
